import React, { useState, useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { save } from './api-observacao-aluno';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch, useSelector } from 'react-redux';
import { addObservacoesAluno, updateObservacoesAluno, setObservacaoAluno as setObservacaoAlunoRedux } from './actions/actions';
import Grid from '@mui/material/Grid';
import CloseIcon from '@mui/icons-material/Close';
import CircularProgress from '@mui/material/CircularProgress';
import { errorMessage } from '../../util/ConfirmAlertUtil';
import TextFieldDate from '../UI/TextFieldDate';
import dayjs from 'dayjs';

const useStyles = makeStyles(theme => ({
    paper: {
        marginTop: '20px',
        display: 'flex',
        flexDirection: 'column',

    },
    form: {
        width: '100%', // Fix IE 11 issue.
        // marginTop: theme.spacing(1),
    },
    title: {
        flex: '1 1 100%',
        paddingTop: '20px;'
    },
    submit: {
        // margin: theme.spacing(3, 0, 2),
    },
    closeIcon: {
        marginTop: '20px',
        marginBottom: '20px',
        cursor: 'pointer'
    },
    loading: {
        marginRight: '10px',
        marginLeft: '10px'
    }
}));

export default function ObservacaoAlunoForm() {
    const classes = useStyles();
    const observacaoAlunoRedux = useSelector(state => state.observacaoAluno);
    const tdp = useSelector(state => state.tdp);
    const alunoTurma = useSelector(state => state.alunoTurma);
    const [observacaoAluno, setObservacaoAluno] = useState({
        tdp: tdp,
        aluno: alunoTurma.aluno
    });
    const [isLoadingSave, setIsLoadingSave] = useState(false);


    useEffect(() => {
        setObservacaoAluno(observacaoAlunoRedux);
    }, [observacaoAlunoRedux])

    const dispatch = useDispatch();

    const handleChange = (event) => {
        setObservacaoAluno({
            ...observacaoAluno,
            [event.target.name]: event.target.value
        })
    }

    const handleDataChange = (data) => {

        setObservacaoAluno({
            ...observacaoAluno,
            data: dayjs(data)
        })
    }

    const clickSubmit = (event) => {
        event.preventDefault();
        setIsLoadingSave(true);
        const codObservacaoAluno = observacaoAluno.codigo;
        save(observacaoAluno).then(data => {
            if (data) {
                if (data.error) {
                    errorMessage(data.message);
                } else {
                    toast.success("Salvo com sucesso.", {
                        position: "bottom-left"
                    });
                    if (codObservacaoAluno) {
                        dispatch(updateObservacoesAluno(data));
                    } else {
                        dispatch(addObservacoesAluno(data));
                    }
                    dispatch(setObservacaoAlunoRedux(null));
                }
            }
            setIsLoadingSave(false);
        });
    }


    return (
        <div>
            <Grid container spacing={3}>
                <Grid size={12}>
                    <Container className={classes.paper} component={Paper} maxWidth="sm">
                        <CloseIcon
                            onClick={() => dispatch(setObservacaoAlunoRedux(null))}
                            className={classes.closeIcon}
                            fontSize='small'
                        />
                        <form onSubmit={clickSubmit}>
                            <TextFieldDate
                                fullWidth
                                required
                                label="Data"
                                value={observacaoAluno && observacaoAluno.data ? observacaoAluno.data : null}
                                onChange={handleDataChange}
                                
                            />
                            <TextField
                                variant="outlined"
                                margin="normal"
                                size='small'
                                multiline
                                rows="4"
                                fullWidth
                                label="Conteúdo"
                                name="conteudo"
                                onChange={handleChange}
                                value={observacaoAluno && observacaoAluno.conteudo ? observacaoAluno.conteudo : ''}
                                slotProps={{
                                    htmlInput: { maxLength: 2000 }
                                }}
                            />
                            <Button
                                type="submit"
                                disabled={isLoadingSave}
                                variant="contained"
                                color="primary"
                                className={classes.submit}>
                                {isLoadingSave && <CircularProgress className={classes.loading} color="primary" size={20} />}
                                Salvar
                            </Button>
                        </form>
                    </Container>
                </Grid>
            </Grid>
        </div>
    );
}